import { Wrapper } from '@american-autonomy/ag-ui';

import SingleSelectPanel from 'components/SingleSelectPanel';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { ENTITY_TYPE, TEST_ID } from './constants';
import type { BoundaryFieldSchema, FunctionComponent, Props } from './types';

const BoundarySelectPanelField: FunctionComponent<Props> = ({
    className = '',
    onChange,
    onClose,
    siteId,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const {
        boundaryItems,
        getSectionKey,
        handleAsyncFilter,
        hasNextPage,
        isLoading,
        noItemsText,
        onNextPage,
        sections
    } = useData({ siteId });

    const handleSelected = (boundary: BoundaryFieldSchema) => {
        onChange(boundary);
        onClose?.(boundary);
    };

    return (
        <Wrapper className={className} testId={testId}>
            <SingleSelectPanel
                entityType={ENTITY_TYPE}
                getSectionKey={getSectionKey}
                hasNextPage={hasNextPage}
                isLoading={isLoading}
                itemSelected={value}
                items={boundaryItems}
                label={SEARCH}
                noItemsFoundText={noItemsText}
                onFilter={handleAsyncFilter}
                onNextPage={onNextPage}
                onSelected={handleSelected}
                sections={sections}
            />
        </Wrapper>
    );
};

export default BoundarySelectPanelField;
